export default __webpack_public_path__ + "static/media/smiley-emoji.bcf903a5.svg";